<div class="header">
  <!-- Left logo -->
  <div class="icon-container">
    <img src="https://cdn.edugogo.ai/public/8af5014f939277070193ad9297f50000/schools/2a186178-3ef0-41fa-a602-c8269ac7820a.png" alt="Header Icon" />
  </div>

  <!-- Right navigation buttons -->
  <div style="display: flex; align-items: center;">
    <a class="action-btn text-link" href="https://betocrypto.edugogo.ai/" target="_blank">
      {{ translations?.header?.products }}
    </a>
    <a class="action-btn black-btn" href="https://betocrypto.edugogo.ai/inicio-sesion" target="_blank">
      {{ translations?.header?.login }}
    </a>
    <a class="action-btn purple-btn" href="https://betocrypto.edugogo.ai/registro" target="_blank">
      {{ translations?.header?.register }}
    </a>

    <!-- Mobile Dropdown -->
    <div class="menu-selector" *ngIf="isMobileView">
      <button class="menu-btn" (click)="toggleMenuDropdown()">☰</button>
      <div class="dropdown" *ngIf="menuDropdownOpen">
        <a href="https://betocrypto.edugogo.ai/" target="_blank" class="dropdown-item">
          {{ translations?.header?.products }}
        </a>
        <a href="https://betocrypto.edugogo.ai/inicio-sesion" target="_blank" class="dropdown-item">
          {{ translations?.header?.login }}
        </a>
        <a href="https://betocrypto.edugogo.ai/registro" target="_blank" class="dropdown-item">
          {{ translations?.header?.register }}
        </a>
      </div>
    </div>
  </div>
</div>
